export const state = () => (require('@pleinair/bigcolony-vue/store/order/_state')())
export const mutations = require('@pleinair/bigcolony-vue/store/order/_mutations')
export const actions = require('@pleinair/bigcolony-vue/store/order/_actions')